import React, { useState } from 'react';
import './gallery-card.css';
import Card from '../../lib/card/Card';
import { Project } from '../../pages/Gallery';
import Popup from '../../lib/popup/Popup';
import DropdownMenuPopup from '../../lib/dropdown/DropdownMenuPopup';
import { IDropdownMenuCardOption } from '../../lib/dropdown/DropdownMenuCard';

interface GalleryCardProps {
	project: Project;
	onClick?: (e: React.MouseEvent<HTMLDivElement>, projectId: string) => any;
	coverPictureUrl?: string;
	options?: IDropdownMenuCardOption<string>[];
	popup?: React.ReactNode;
	viewMode?: 'grid' | 'rows';
}

const GalleryCard: React.FC<GalleryCardProps> = ({
	project,
	onClick,
	options,
	popup,
	coverPictureUrl,
	viewMode = 'grid',
}) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const dropdownOptions: IDropdownMenuCardOption<string>[] = options || [];

	if (viewMode === 'rows') {
		const handleRowClick = (e: React.MouseEvent<HTMLDivElement>) => {
			if (onClick) {
				onClick(e, project.id);
			}
		};

		return (
			<>
				<div
					onClick={handleRowClick}
					className='gallery-row-card'
					id={`gallery-card--row--${project.id}`}
				>
					<div className='gallery-row-card-left'>
						{coverPictureUrl ? (
							<img src={coverPictureUrl} className='gallery-row-card-image' />
						) : (
							<div
								className={`gallery-row-card-image bg-color-${project.assignedFallbackColor}`}
							>
								<i className='fa-solid fa-server'></i>
							</div>
						)}
						<div className='gallery-row-card-info'>
							<h3 className='gallery-row-card-title all-uppercase'>
								{project.name || 'untitled'}
							</h3>
							<p className='gallery-row-card-description'>{project.description || ''}</p>
						</div>
					</div>
					<div className='gallery-row-card-right'>
						{/* Three dot menu */}
						{!!dropdownOptions.length && (
							<button
								className='gallery-row-card-menu-icon'
								onClick={(e) => {
									e.stopPropagation();
									setIsMenuOpen((prev: boolean) => !prev);
								}}
								id={`gallery-card--info-section--menu-icon--${project.id}`}
							>
								<i className='fa-solid fa-ellipsis-v'></i>
							</button>
						)}
					</div>
				</div>
				{!!dropdownOptions.length && (
					<DropdownMenuPopup
						popupOptions={{
							anchorQuerySelector: `#gallery-card--info-section--menu-icon--${project.id}`,
							placement: 'bottom-end',
							open: isMenuOpen,
							onClickAway: () => setIsMenuOpen(false)
						}}
						options={dropdownOptions.map((opt) => ({
							...opt,
							onClick: async (e, val) => {
								setIsMenuOpen(false);
								opt.onClick?.(e, val);
							}
						}))}
					/>
				)}
				{!!popup && (
					<Popup
						anchorQuerySelector={`#gallery-card--row--${project.id}`}
						placement='bottom'
						openDelay={500}
						closeDelay={100}
					>
						{popup}
					</Popup>
				)}
			</>
		);
	}

	const handleGridClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (onClick) {
			onClick(e, project.id);
		}
	};

	return (
		<>
			<Card onClick={handleGridClick}>
				<div className='card-content' style={{ position: 'relative' }}>
					{coverPictureUrl ? (
						<img src={coverPictureUrl} className='card-image' />
					) : (
						<div
							className={`card-image bg-color-${project.assignedFallbackColor}`}
						>
							<i className='fa-solid fa-server'></i>
						</div>
					)}
					<div
						className='card-info-section'
						id={`gallery-card--info-section--${project.id}`}
					>
						<div
							className='card-info-section--left--with-menu'
							id={`gallery-card--info-section--${project.id}`}
						>
							<h3 className='card-title truncated-title all-uppercase'>
								{project.name || 'untitled'}
							</h3>
							<p className='card-description'>{project.description || ''}</p>
						</div>
						{/* Three dot menu */}
						{!!dropdownOptions.length && (
							<button
								className='card-info-section--right card-info-section--menu-icon'
								onClick={(e) => {
									e.stopPropagation();
									setIsMenuOpen((prev: boolean) => !prev);
								}}
								id={`gallery-card--info-section--menu-icon--${project.id}`}
							>
								<i
									className='fa-solid fa-ellipsis-v'
								></i>
							</button>
						)}
					</div>
					<div className='card-top-right-content'>
						{/* <LocalOnlineUsers onlineUsers={[]} /> */}
					</div>
				</div>
			</Card>
			{!!dropdownOptions.length && (
				<DropdownMenuPopup
					popupOptions={{
						anchorQuerySelector: `#gallery-card--info-section--menu-icon--${project.id}`,
						placement: 'right',
						open: isMenuOpen,
						onClickAway: () => setIsMenuOpen(false)
					}}
					options={dropdownOptions.map((opt) => ({
						...opt,
						onClick: async (e, val) => {
							setIsMenuOpen(false);
							opt.onClick?.(e, val);
						}
					}))}
				/>
			)}
			{!!popup && (
				<Popup
					anchorQuerySelector={`#gallery-card--info-section--${project.id}`}
					placement='bottom'
					// open
					openDelay={500}
					closeDelay={100}
				>
					{popup}
				</Popup>
			)}
		</>
	);
};

export default GalleryCard;
